import React from "react";

import {
  Button,
  Content,
  Grid,
  GridItem,
  Stack,
  StackItem
} from "@patternfly/react-core";

import { SectionPanel } from "shared/components/SectionPanel";

import NewsCard from "./NewsCard";

const NewsPanel = ({
  news = [],
  isCard = false,
  variant="primary",
  showHeader = true,
  showAction = true,
  title = "Aktualności",
  description =
    "Informacje, wydarzenia, sukcesy uczniów i relacje z życia szkoły.",
  actionLabel = "Wszystkie aktualności",
  actionHref = null
}) => {
  if (!Array.isArray(news) || news.length === 0) {
    return null;
  }

  const header =
    showHeader && (title || description) ? (
      <Grid>
        <GridItem
          span={10}
          offset={1}
          lg={8}
          lgOffset={2}
        >
          <Stack hasGutter>
            {title && (
              <StackItem>
                <Content
                  component="h1"
                  style={{ textAlign: "center" }}
                > 
                  {title}
                </Content>
              </StackItem>
            )}

            {description && (
              <StackItem>
                <Content
                  component="p"
                  style={{ textAlign: "center" }}
                >
                  {description}
                </Content>
              </StackItem>
            )}
          </Stack>
        </GridItem>
      </Grid>
    ) : null;

  const action =
    showAction && actionHref ? (
      <Button
        component="a"
        href={actionHref}
        variant="secondary"
      >
        {actionLabel}
      </Button>
    ) : null;

  return (
    <SectionPanel
      isCard={isCard}
      variant={variant}
      header={header}
      action={action}
    >
      <Grid hasGutter>
        {news.map((item) => (
          <GridItem
            key={item.id}
            span={12}
            md={6}
            xl={3}
          >
            <NewsCard news={item} />
          </GridItem>
        ))}
      </Grid>
    </SectionPanel>
  );
};

export default NewsPanel;